// ES5 as server.js will consume this file.

module.exports = {
  zendeskChatApiKey: '39QZJ8i5vb81gJGdC4ylSD6kTQqKgNAr',
  // These are already translated and don't need to be translated again; they will
  // always be in their mother tongue.
  languageNameMap: {
    ar: { name: 'اللغة العربية' },
    'ar-KW': { name: 'اللغة العربية (الكويت)' },
    de: { name: 'Deutsch' },
    en: { name: 'English' },
    es: { name: 'Español' },
    fr: { name: 'Français' },
    it: { name: 'Italiano' },
    'nl-BE': { name: 'Nederlands (België)' },
    nl: { name: 'Nederlands' },
    zh: { name: '中文 - 香港' },
    'zh-TW': { name: '中文 - 台灣' },
  },
  languages: ['ar', 'ar-KW', 'de', 'en', 'es', 'fr', 'it', 'nl', 'nl-BE', 'zh', 'zh-TW'],
  countries: [
    {
      tld: 'uk',
      host: 'deliveroo.co.uk',
      isoCode: 'GB',
      languages: ['en'],
      examplePostcode: 'EC4R 3TE',
      postcodeSearch: true,
      riderInviteLink: true,
      restaurantsHomepageUrl: 'https://restaurants.deliveroo.com/',
      appRatings: {
        itunesCount: '6,002',
        itunesRating: 4.69,
        googleCount: '16,925',
        googleRating: 4.28,
      },
      enableDeliverooForBusiness: true,
      salesforceKey: 'UK',
    },
    {
      tld: 'au',
      host: 'deliveroo.com.au',
      isoCode: 'AU',
      languages: ['en'],
      postcodeSearch: false,
      riderInviteLink: true,
      restaurantsHomepageUrl: 'https://restaurants.deliveroo.com/',
      appRatings: {
        itunesCount: '1,263',
        itunesRating: 4.78,
        googleCount: '16,925',
        googleRating: 4.28,
      },
      enableDeliverooForBusiness: true,
      salesforceKey: 'Australia',
    },
    {
      tld: 'be',
      host: 'deliveroo.be',
      isoCode: 'BE',
      languages: ['en', 'fr', 'nl-BE'],
      examplePostcode: '1050',
      postcodeSearch: false,
      riderInviteLink: true,
      restaurantsHomepageUrl: '/restaurant-signup',
      appRatings: {
        itunesCount: '392',
        itunesRating: 4.7,
        googleCount: '16,925',
        googleRating: 4.28,
      },
      enableDeliverooForBusiness: true,
      salesforceKey: 'Belgium',
    },
    {
      tld: 'fr',
      host: 'deliveroo.fr',
      isoCode: 'FR',
      languages: ['fr', 'en'],
      postcodeSearch: false,
      riderInviteLink: false,
      restaurantsHomepageUrl: 'https://restaurants.deliveroo.com/',
      appRatings: {
        itunesCount: '2,517',
        itunesRating: 4.65,
        googleCount: '16,925',
        googleRating: 4.28,
      },
      enableDeliverooForBusiness: true,
      salesforceKey: 'France',
    },
    {
      tld: 'de',
      host: 'deliveroo.de',
      isoCode: 'DE',
      languages: ['de', 'en'],
      postcodeSearch: false,
      riderInviteLink: false,
      restaurantsHomepageUrl: '/restaurant-signup',
      appRatings: {
        itunesCount: '698',
        itunesRating: 4.66,
        googleCount: '16,925',
        googleRating: 4.28,
      },
      enableDeliverooForBusiness: true,
      salesforceKey: 'Germany',
    },
    {
      tld: 'hk',
      host: 'deliveroo.hk',
      isoCode: 'HK',
      languages: ['en', 'zh'],
      postcodeSearch: false,
      riderInviteLink: false,
      restaurantsHomepageUrl: 'https://restaurants.deliveroo.com/',
      appRatings: {
        itunesCount: '515',
        itunesRating: 4.69,
        googleCount: '16,925',
        googleRating: 4.28,
      },
      enableDeliverooForBusiness: true,
      salesforceKey: 'Hong Kong',
    },
    {
      tld: 'ie',
      host: 'deliveroo.ie',
      isoCode: 'IE',
      languages: ['en'],
      postcodeSearch: false,
      riderInviteLink: true,
      restaurantsHomepageUrl: 'https://restaurants.deliveroo.com/',
      appRatings: {
        itunesCount: '225',
        itunesRating: 4.7,
        googleCount: '16,925',
        googleRating: 4.28,
      },
      enableDeliverooForBusiness: true,
      salesforceKey: 'Ireland',
    },
    {
      tld: 'it',
      host: 'deliveroo.it',
      isoCode: 'IT',
      languages: ['it', 'en'],
      postcodeSearch: false,
      riderInviteLink: false,
      restaurantsHomepageUrl: '/restaurant-signup',
      appRatings: {
        itunesCount: '493',
        itunesRating: 4.72,
        googleCount: '16,925',
        googleRating: 4.28,
      },
      enableDeliverooForBusiness: true,
      salesforceKey: 'Italy',
    },
    {
      tld: 'nl',
      host: 'deliveroo.nl',
      isoCode: 'NL',
      languages: ['nl', 'en'],
      examplePostcode: '1017EM',
      postcodeSearch: true,
      riderInviteLink: true,
      restaurantsHomepageUrl: '/restaurant-signup',
      appRatings: {
        itunesCount: '243',
        itunesRating: 4.56,
        googleCount: '16,925',
        googleRating: 4.28,
      },
      enableDeliverooForBusiness: true,
      salesforceKey: 'Netherlands',
    },
    {
      tld: 'sg',
      host: 'deliveroo.com.sg',
      isoCode: 'SG',
      languages: ['en'],
      postcodeSearch: true,
      examplePostcode: '069535',
      riderInviteLink: true,
      restaurantsHomepageUrl: 'https://restaurants.deliveroo.com/',
      appRatings: {
        itunesCount: '794',
        itunesRating: 4.71,
        googleCount: '16,925',
        googleRating: 4.28,
      },
      enableDeliverooForBusiness: true,
      salesforceKey: 'Singapore',
    },
    {
      tld: 'es',
      host: 'deliveroo.es',
      isoCode: 'ES',
      languages: ['es', 'en'],
      postcodeSearch: false,
      riderInviteLink: false,
      restaurantsHomepageUrl: '/restaurant-signup',
      appRatings: {
        itunesCount: '713',
        itunesRating: 4.75,
        googleCount: '16,925',
        googleRating: 4.28,
      },
      enableDeliverooForBusiness: true,
      salesforceKey: 'Spain',
    },
    {
      tld: 'ae',
      host: 'deliveroo.ae',
      isoCode: 'AE',
      languages: ['en'],
      postcodeSearch: false,
      riderInviteLink: false,
      restaurantsHomepageUrl: 'https://restaurants.deliveroo.com/',
      appRatings: {
        itunesCount: '493',
        itunesRating: 4.8,
        googleCount: '16,925',
        googleRating: 4.28,
      },
      enableDeliverooForBusiness: true,
      salesforceKey: 'United Arab Emirates',
    },
    {
      tld: 'tw',
      host: 'deliveroo.tw',
      isoCode: 'TW',
      languages: ['zh-TW', 'en'],
      postcodeSearch: false,
      riderInviteLink: false,
      restaurantsHomepageUrl: 'https://restaurants.deliveroo.com/',
      appRatings: {
        itunesCount: '0',
        itunesRating: 0,
        googleCount: '0',
        googleRating: 0,
      },
      enableDeliverooForBusiness: false,
      salesforceKey: 'Taiwan',
    },
    {
      tld: 'kw',
      host: 'deliveroo.com.kw',
      isoCode: 'KW',
      languages: ['en', 'ar-KW'],
      postcodeSearch: false,
      riderInviteLink: false,
      restaurantsHomepageUrl: 'https://restaurants.deliveroo.com/',
      appRatings: {
        itunesCount: '0',
        itunesRating: 0,
        googleCount: '0',
        googleRating: 0,
      },
      enableDeliverooForBusiness: false,
      salesforceKey: 'Kuwait',
    },
  ],
};
